import { axios } from '@/axios.config';
import { saveErrorLog } from '@/lib/error';

export default {
  // Settings
  /**
   * POST RESET/SEND
   */
  postResetSend(state, arg) {
    return axios.post('/reset/send', arg).catch(err => {
      saveErrorLog(err);
      throw new Error();
    });
  },
  /**
   * POST RESET/VERIFY
   */
  postResetVerify(state, arg) {
    const params = { digits: arg.digits, hash: arg.hash, second: arg.second };
    return axios.post('/reset/verify', params).catch(err => {
      saveErrorLog(err);
      throw new Error();
    });
  },

  /**
   * PUT RESET/PASSWORD/{EMAIL}
   */
  putResetPassword(state, arg) {
    return axios.put(`/reset/password/${arg.email}`, arg).catch(() => {});
  },

  /**
   * PUT USER/EMAIL (Login ID)
   */
  putUserEmail(state, arg) {
    // const params = JSON.stringify({ email: arg.email, password: arg.password });
    const params = { email: arg.email, password: arg.password };
    return axios.patch('/user/email', params).catch(() => {
      throw new Error();
    });
  },

  /**
   * POST /USER/PASSWORD
   */
  postUserPassword({ commit }, arg) {
    let params = { pw_old: arg.currentPassword, pw_new: arg.newPassword };

    return axios
      .patch('/user/password', params)
      .then(res => {
        if (res.data.status === 'error') {
          commit('IS_WRONG_PASSWORD', true);
          throw new Error('wrong password');
        }
      })
      .catch(() => {
        commit('IS_WRONG_PASSWORD', true);
        throw new Error('wrong password');
      });
  },

  /**
   * POST /USER/SETTING
   */
  postUserSettings({ commit, dispatch, state }, params) {
    commit('SETTING_UPDATE_REQUEST');

    return axios
      .post('/user/setting', params)
      .then(async () => {
        commit('SETTING_UPDATE_SUCCESS');

        // Fetch user info
        await dispatch('user/fetchUser', null, { root: true });
        if (state.accessGroup) {
          await dispatch('user/fetchAccessGroup', null, { root: true });
        }
      })
      .catch(err => {
        commit('SETTING_UPDATE_FAILURE', err);
      });
  },

  /**
   * Get current vendor from session storage.
   * default: aws
   * @param commit
   * @return {Promise<void>}
   */
  fetchVendor({ commit }) {
    const vendorFromSessionStorage = sessionStorage.getItem('wave_vendor');

    commit('updateVendor', vendorFromSessionStorage ? vendorFromSessionStorage : 'aws');

    return Promise.resolve();
  },

  /**
   * Update current vendor / Save to session storage.
   * @param commit
   * @param vendor {string}
   * @return {Promise<void>}
   */
  updateVendor({ commit }, vendor) {
    commit('updateVendor', vendor);

    sessionStorage.setItem('wave_vendor', vendor);

    // Reset usage reports state
    commit('usageReports/reset', null, { root: true });
  },
};
